import React, { useContext, useState } from "react"; // useEffect
import classes from "./Sendenquirynew.module.css";
import axios from "../../../../Axios";
import { toast } from "react-toastify";
import { getCompanyFolderName, getUserFolderName } from "../../../../Utility";
import { Urls } from "../../../../Urls";
import Axios from "axios";
import { currentRequestTimeStamp } from "../../../../Constants";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const Sendenquirynew = ({ refresh, transporter }) => {
  const { userDetails, companyProfile } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails, companySettingData
  );
  const [sendenquiryinmail, setsendenquiryinmail] = useState({
    subject: transporter.available_location
      ? `Enquiry for ${transporter.origin.location.location} TO ${transporter.destination.length > 0
        ? transporter.destination.map((data) =>
          data.location ? data.location.location : null
        )
        : "Not Specified"
      }`
      : "",
    message: "",
  });
  const [attachments, setAttachments] = useState([]);

  const changeHandler = (e) => {
    setsendenquiryinmail({
      ...sendenquiryinmail,
      [e.target.id]: e.target.value,
    });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: `transporter enquiries`,
      Data: `None`,
      Definition: `user has clicked on submit send message for logistics enquiry`,
    });
    let userFiles = [];
    let timeStamp = "";
    const t = new Date().toISOString();
    let dateString = t.split("T")[0];
    let timeString = t.split("T")[1];
    dateString = dateString.replace(/-/g, "");
    timeString = timeString.replace(/:/g, "");
    timeString = timeString.replace(".", "");
    timeString = timeString.split("Z")[0];
    timeStamp += dateString + timeString;
    for (let i = 0; i < attachments.length; i++) {
      userFiles.push({
        filePath: `company/${getCompanyFolderName(userDetails.email)}/${getUserFolderName(userDetails.email, companyProfile?.domain_data?.company_id)}/${timeStamp}-${attachments[
          i
        ]["name"].replace(/ /g, "-")}`,
        fileName: attachments[i]["name"],
        fileData: attachments[i],
      });
    }

    const uploadAttachments = function () {
      return new Promise((resolve, reject) => {
        if (userFiles.length > 0) {
          // Upload files to storage
          let totalFilesUploaded = 0;
          let totalFilesToUpload = userFiles.length;
          userFiles.map((file) => {
            let body = {
              fileName: file["filePath"],
              accountName: "lnclientdata",
              containerName: "enquiries",
              action: "upload",
            };
            Axios.post(Urls.fileService, body)
              .then((res) => {
                // Call `PUT` request for uploading file to storage with url recieved from API
                Axios.put(res.data.url, file["fileData"], {
                  headers: {
                    "x-ms-blob-type": "blockblob",
                    "x-ms-blob-content-disposition": file["fileData"]["type"],
                  },
                })
                  .then((res) => {
                    totalFilesUploaded += 1;
                    if (totalFilesUploaded === totalFilesToUpload) {
                      resolve({
                        status: "success",
                      });
                    }
                  })
                  .catch((error) => {
                    toast.error("Error while uploading your attachments");
                    console.log(error);
                  });
              })
              .catch((error) => {
                console.log(error);
                reject({
                  status: "failed",
                  message: error,
                });
              });
            // return
          });
        } else {
          resolve({
            status: "success",
          });
        }
      });
    };

    if (sendenquiryinmail.message === "" || sendenquiryinmail.subject === "") {
      toast.info("Subject or message can not be empty!");
    } else {
      uploadAttachments()
        .then((res) => {
          const data = {
            createdOn: new Date().toISOString(),
            subject: transporter.available_location
              ? `Enquiry for ${transporter.origin.location.location} TO ${transporter.destination.length > 0
                ? transporter.destination.map((data) =>
                  data.location ? data.location.location : null
                )
                : "Not Specified"
              }`
              : sendenquiryinmail.subject,
            thread_id: timeStamp,
            newThread: [
              {
                content: sendenquiryinmail.message,
                created: new Date().toISOString(),
                by: {
                  user_type: "company",
                  user: {
                    name: userDetails.user_name,
                    email: userDetails.email,
                  },
                },
                attachments: userFiles,
                status: "unread",
              },
            ],
            users: {
              company: [
                {
                  name: userDetails.user_name,
                  email: userDetails.email,
                  user_id: userDetails?.profile_company_id,
                  company_name: userDetails?.email.split("@")[1]
                    .split(".")[0]
                    .toUpperCase(),
                },
              ],
              transporter: transporter.contact_information.map((user) => {
                return {
                  name: user["name"],
                  email: user["email"],
                  transporter_id: transporter.transporter_id,
                  transporter_name: transporter.transporter_name,
                };
              }),
            },
            is_new: true,
          };
          console.clear();
          // console.log(data)
          axios
            .post(Urls.inmail, data)
            .then((res) => {
              toast.success("Enquiry has been sent!");
              if (transporter.available_location) {
                // window.location.reload()
                refresh(true);
              }
              setsendenquiryinmail({
                subject: "",
                message: "",
              });
              setAttachments([]);
              if (!transporter.available_location) {
                document.querySelector("#closeSendEnquiryModal").click();
              }
              Promise.all([
                sendMailUpdate(data, "company"),
                sendMailUpdate(data, "transporter"),
              ])
                .then((res) => {
                  // console.log(res)
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          toast.error("Error while uploading your files");
          console.log(error);
        });
    }
  };

  const updateAttachments = (event) => {
    event.preventDefault();
    setAttachments(event.target.files);
  };

  const date_conversion = (dateinput) => {
    var date_considered = new Date(dateinput);
    var dd = date_considered.getDate();
    var mm = date_considered.getMonth() + 1;
    var yyyy = date_considered.getFullYear();
    var hours = date_considered.getHours();
    var minutes = date_considered.getMinutes();
    var month_name = new Array([]);
    month_name[1] = "Jan";
    month_name[2] = "Feb";
    month_name[3] = "Mar";
    month_name[4] = "Apr";
    month_name[5] = "May";
    month_name[6] = "Jun";
    month_name[7] = "Jul";
    month_name[8] = "Aug";
    month_name[9] = "Sep";
    month_name[10] = "Oct";
    month_name[11] = "Nov";
    month_name[12] = "Dec";
    var name_month = month_name[mm];
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    date_considered = `${name_month}${" "}${dd}, ${yyyy}${" "}${hours}:${minutes}`;
    return date_considered;
  };

  const getEmailBody = function (thread, user, userType, transporter) {
    let emailBody = {};
    if (userType === "transporter") {
      if (transporter.available_location) {
        // console.log(user)
        // console.log(thread)
        // console.log(thread['users']['company'][0]['company_name'])
        // console.log(transporter)
        emailBody = {
          type: "superlaunch",
          activity: "Email Request",
          mail_status: "Pending",
          from_email: "lorri@logisticsnow.in",
          user_type: "transporter",
          subject: `Business enquiry received!`,
          to_email: user["email"],
          cc: "connect@logisticsnow.in",
          Application_name: "lorri",
          module_name: "transporterclientscreen",
          timestamp: currentRequestTimeStamp(),
          content: `<div><p>Dear ${user["name"]},</p>
                    <p>Congratulations ! You have received business enquiry from ${thread["users"]["company"][0]["company_name"]
            }  </p>
                    <p>
                    ${transporter.destination.length > 0 &&
              transporter.truck_type.length > 0
              ? `    
                        ${transporter.origin.location.location
              } to ${transporter.destination.map((data) =>
                data.location ? data.location.location : null
              )} ${transporter.truck_type.map((item) => item.label)}
                        `
              : transporter.truck_type.length > 0
                ? `                  
                        ${transporter.origin.location.location
                }  ${transporter.truck_type.map((item) => item.label)}
                        `
                : `
                        ${transporter.origin.location.location} 
                        `
            }
                    </p>
                    <p>To view the enquiry click here <a href='https://transporter.lorri.in' target="_blank" rel="noreferrer noopener" >LoRRI Mails</a></p>
                    <p>Should you need any assistance or have a question, please email (lorri@logisticsnow.in) or just call +91-8928008311 or +91-9867773519 </p>
                    <p>Warm Regards,<br/>Team LoRRI </p>
                    </div>`,
        };
      } else {
        // console.log(transporter)

        emailBody = {
          type: "superlaunch",
          activity: "Email Request",
          mail_status: "Pending",
          from_email: "lorri@logisticsnow.in",
          user_type: "transporter",
          subject: `Business enquiry received!`,
          to_email: user["email"],
          Application_name: "lorri",
          module_name: "transporterclientscreen",
          timestamp: currentRequestTimeStamp(),
          cc: "connect@logisticsnow.in",
          content: `<div><p>Dear ${user["name"]},</p>
                    <p>Congratulations ! You have received a Business Enquiry from ${thread["users"]["company"][0]["company"][0][
            "company_name"
            ]
            } on ${date_conversion(new Date().toISOString())}.</p>
                    <p>Click here to view <a href='https://transporter.lorri.in' target="_blank" rel="noreferrer noopener" >LoRRI Mails</a></p>
                    <p>Should you need any assistance or have a question, please email (lorri@logisticsnow.in) or just call +91-8928008311 or +91-9867773519 </p>
                    <p>Warm Regards,<br/>Team LoRRI </p>
                    </div>`,
        };
      }
    } else {
      if (transporter.available_location) {
        emailBody = {
          type: "superlaunch",
          activity: "Email Request",
          mail_status: "Pending",
          Application_name: "lorri",
          module_name: "transporterclientscreen",
          timestamp: currentRequestTimeStamp(),
          from_email: "connect@logisticsnow.in",
          user_type: "company",
          subject: `Your enquiry for ${transporter.destination.length > 0
              ? `    
                        ${transporter.origin.location.location
              } to ${transporter.destination.map((data) =>
                data.location ? data.location.location : null
              )} 
                        `
              : `
                        ${transporter.origin.location.location} 
                        `
            } `,
          to_email: user["email"],
          cc: "associate@logisticsnow.in",
          content: `<div><p>Dear ${user["name"]},</p>
                    <p>Congrats your enquiry has been submitted to ${thread["users"]["transporter"][0]["transporter_name"]}.</p>
                    <p>To view the response from ${thread["users"]["transporter"][0]["transporter_name"]} visit <a href='https://company.lorri.in/LorriInMail' target="_blank" rel="noreferrer noopener" >LoRRI Mails</a></p>
                    <p>Should you need any assistance or have a question, please email (associate@logisticsnow.in) or just call +91-9653620207 or +91-9867773508 </p>
                    <p>Warm Regards,<br/>Team LoRRI </p>
                    </div>`,
        };
        // <p>Congrats your enquiry has been submitted to ${thread['users']['transporter'][0]['transporter_name']}.</p>
      } else {
        emailBody = {
          type: "superlaunch",
          activity: "Email Request",
          mail_status: "Pending",
          from_email: "connect@logisticsnow.in",
          user_type: "company",
          Application_name: "lorri",
          module_name: "transporterclientscreen",
          timestamp: currentRequestTimeStamp(),
          subject: `Your enquiry has been sent sucessfully!`,
          to_email: user["email"],
          cc: "associate@logisticsnow.in",
          content: `<div><p>Dear ${user["name"]},</p>
                    <p>You have sucessfully sent the enquiry to ${thread["users"]["transporter"][0]["transporter_name"]
            } on ${date_conversion(new Date().toISOString())}.</p>
                    <p>To view the message visit <a href='https://company.lorri.in/LorriInMail' target="_blank" rel="noreferrer noopener" >LoRRI Mails</a></p>
                    <p>Should you need any assistance or have a question, please email (associate@logisticsnow.in) or just call +91-9653620207 or +91-9867773508 </p>
                    <p>Warm Regards,<br/>Team LoRRI </p>
                    </div>`,
        };
      }
    }

    return emailBody;
  };

  const sendMailUpdate = function (thread, userType) {
    return new Promise((resolve, reject) => {
      if (thread) {
        let users = thread["users"][userType];
        users.map((user) => {
          axios
            .post(
              "https://lorriclient.azurefd.net/api/log",
              getEmailBody(thread, user, userType, transporter)
            )
            .then((res) => {
              resolve(true);
            })
            .catch((error) => {
              console.log(error);
              reject(false);
            });
        });
      } else {
        reject(false);
      }
    });
  };

  return (
    <div>
      <div align="left">
        <div className={`${classes["sendlogisticstextdiv"]} row`}>
          <div className="col-md-1 col-sm-12">To:</div>
          <div className="col-md-11 col-sm-12">
            {transporter.transporter_name}
          </div>
        </div>
        {/* <div class={`${classes['sendlogisticstextdiv']} row`}>
                    <div className="col-md-3 col-sm-12">
                        Enquiry ID:
                    </div>
                    <div className="col-md-3 col-sm-12">
                        456789
                    </div>
                </div> */}
        {/* <div class={`${classes['sendlogisticstextdiv']} row`}>
                    <div className="col-md-3 col-sm-12">
                        Type:
                    </div>
                    <div className="col-md-8 col-sm-12">
                        <select className="form-control">
                            <option>Generic Enquiry</option>
                            <option>Truck Availability</option>
                        </select>
                    </div>
                </div> */}
        <div>
          {transporter.available_location ? (
            <>
              <input
                required={true}
                value={`Enquiry for ${transporter.origin.location.location
                  } TO ${transporter.destination.length > 0
                    ? transporter.destination.map((data) =>
                      data.location ? data.location.location : null
                    )
                    : "Not Specified"
                  }`}
                className="form-control form-control-sm"
                type="text"
                id="subject"
                placeholder="Subject: Enter subject line"
              />
            </>
          ) : (
            <>
              <input
                required={true}
                value={sendenquiryinmail["subject"]}
                onChange={(e) => changeHandler(e)}
                className="form-control form-control-sm"
                type="text"
                id="subject"
                placeholder="Subject: Enter subject line"
              />
            </>
          )}
          {/* <input required={true} value={sendenquiryinmail['subject']} onChange={e => changeHandler(e)} className="form-control form-control-sm" type="text" id='subject' placeholder="Subject: Enter subject line" /> */}
        </div>
        <div className="form-group">
          <span className={classes["enquiry-characters-allowed"]}>
            1500 characters allowed
          </span>
          <textarea
            maxLength="1500"
            style={{ textAlign: "left" }}
            value={sendenquiryinmail["message"]}
            onChange={(e) => changeHandler(e)}
            placeholder="  Type your response"
            className="form-control"
            id="message"
            rows="4"
          ></textarea>
        </div>
      </div>
      <div className={classes["sendlogisticsbuttondiv"]}>
        <div className={classes["sendlogisticsbutton"]}>
          <button
            onClick={(e) => submitHandler(e)}
            name="contact"
            type="button"
            className="btn btn-success"
          >
            Submit
          </button>
        </div>
        <div className={classes["sendlogisticsbutton"]}>
          <label
            className="btn btn-primary upload-file-button-enquiry"
            htmlFor="my-file-selector"
          >
            <input
              id="my-file-selector"
              onChange={updateAttachments}
              type="file"
              multiple={true}
              className="d-none"
            />
            <i className="fas fa-paperclip"></i>
            {attachments && attachments.length > 0
              ? ` ${attachments.length} files selected`
              : ` Attach files`}
          </label>
        </div>
      </div>
      <hr />
      {/* <div>
                <span>You can mail us at <b> <a href="mailto:connect@logisticsnow.in">connect@logisticsnow.in</a></b> or you can call us at <b><a href="tel:+91 9653620207 "> +91 9653620207  </a> or <a href="tel:+91 9867773508 "> +91 9867773508</a></b> </span>
            </div> */}
    </div>
  );
};

export default Sendenquirynew;
